export default __webpack_public_path__ + "static/SurveyLogo2024-cbfb2ae28c9badb134e5376bf2fa6db5.png";